<template>
	<div v-if="value == 'No Data'" :class="color" class="tagg"
		style="width: 8rem; color: var(--noir); justify-content: space-around">
		<img :src="icon" />
		<p>No Data</p>
	</div>
	<div v-else-if="isInfiniteValue" :class="color" class="tagg" v-tooltip.top="'Not mentioned anymore'">
		<img :src="icon" />
		<p style="margin-left: 0.35rem; color: black" v-if="value !== ''">
			{{ value }}
		</p>
	</div>
	<div v-else :class="color" class="tagg">
		<img :src="icon" />
		<p style="margin-left: 0.35rem; color: black" v-if="value !== ''">
			{{ value }}
		</p>
	</div>
</template>

<!-- CustomTag.vue -->
<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
	position: [Number, String],
	last_position: [Number, String],
	position_change: {
		type: Object,
		default: null,
	},
});

const structuredChange = computed(() => {
	if (!props.position_change || typeof props.position_change !== 'object') {
		return null;
	}
	if (props.position_change.has_change !== true) {
		return null;
	}
	return props.position_change;
});

const icon = computed(() => {
	if (structuredChange.value) {
		if (structuredChange.value.direction === 'down') {
			return new URL('/src/assets/icon/down-arrow.svg', import.meta.url);
		}
		if (structuredChange.value.direction === 'up') {
			return new URL('/src/assets/icon/up-arrow.svg', import.meta.url);
		}
		return new URL('/src/assets/icon/equal.svg', import.meta.url);
	}
	if (props.last_position === null) {
		return new URL('/src/assets/icon/delete.svg', import.meta.url);
	}
	if (props.position === props.last_position) {
		return new URL('/src/assets/icon/equal.svg', import.meta.url);
	}
	if (props.position > props.last_position) {
		return new URL('/src/assets/icon/down-arrow.svg', import.meta.url);
	}
	if (props.position < props.last_position) {
		return new URL('/src/assets/icon/up-arrow.svg', import.meta.url);
	}
});

const color = computed(() => {
	if (structuredChange.value) {
		if (structuredChange.value.direction === 'down' || structuredChange.value.color === 'red') {
			return 'red';
		}
		if (structuredChange.value.direction === 'up' || structuredChange.value.color === 'green') {
			return 'green';
		}
		return 'yellow';
	}
	if (props.last_position === null) {
		return 'red';
	}
	if (props.position === props.last_position) {
		return 'yellow';
	}
	if (props.position > props.last_position) {
		return 'red';
	}
	if (props.position < props.last_position) {
		return 'green';
	}
});

const value = computed(() => {
	if (structuredChange.value) {
		if (structuredChange.value.display_value === null || structuredChange.value.display_value === undefined) {
			return '';
		}
		return String(structuredChange.value.display_value);
	}
	if (props.last_position === null) {
		return 'No Data';
	}
	if (props.position === props.last_position) {
		return '';
	}
	if (props.position > props.last_position) {
		return (props.position - props.last_position).toString();
	}
	if (props.position < props.last_position) {
		return (props.last_position - props.position).toString();
	}
});

const isInfiniteValue = computed(() => {
	return structuredChange.value?.is_infinite === true || value.value === '∞';
});
</script>

<style lang="scss">
.pi-arrow-right-arrow-left {
	padding-left: 4.5px;
}

.tagg {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0.375rem;
	padding: 0.5rem 0 0.4rem;
	margin-left: 0.3rem;
	width: 2.5rem;
	height: 1.5rem;
	font-size: 0.9rem;
	transform: scale(0.75);

	img {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 0.7rem;
		aspect-ratio: 1/1;
	}

	&.red {
		background-color: var(--rouge-300);
	}

	&.yellow {
		background-color: var(--jaune-500);
	}

	&.green {
		background-color: var(--vert-500);
	}
}
</style>
